import { useState, type FC } from 'react';
import { useMarkAsErroneous } from 'infrastructure/hooks/rpm';

import ErroneousButton from './button';
import ErroneousModal from './modal';

import type { Nullable } from 'infrastructure/types';
import type { QueryKey } from '@tanstack/react-query';

interface Props {
  deviceId: string;
  readingId: string;
  getActivityQueryKey: QueryKey;
  isErroneous?: Nullable<boolean>;
  disabled?: boolean;
}

const ErroneousWrapper: FC<Props> = ({
  getActivityQueryKey,
  deviceId,
  readingId,
  isErroneous,
  disabled,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { markAsErroneous, unMarkAsErroneous, isLoading } = useMarkAsErroneous({
    getActivityQueryKey,
  });

  const handelClick = () => {
    if (isErroneous) {
      unMarkAsErroneous({
        deviceId,
        readingId,
      });
    } else {
      setIsModalOpen(true);
    }
  };

  const handelSuccess = (erroneousReason: string) => {
    setIsModalOpen(false);
    markAsErroneous({
      deviceId,
      readingId,
      erroneousReason,
    });
  };

  return (
    <div>
      <ErroneousButton
        onClick={handelClick}
        isOpen={isModalOpen}
        isErroneous={isErroneous}
        isLoading={isLoading}
        disabled={disabled}
      />

      <ErroneousModal
        isOpen={isModalOpen}
        isLoading={isLoading}
        onClose={() => {
          setIsModalOpen(false);
        }}
        onSuccess={handelSuccess}
      />
    </div>
  );
};
export default ErroneousWrapper;
